// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1N_uM","selected":"Chip_selected__3gxFC"};